var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0074 12.4015C14.0404 11.2273 14.6668 9.68681 14.6668 8.00001C14.6668 4.31811 11.6821 1.33334 8.00016 1.33334C6.31336 1.33334 4.77288 1.9598 3.59869 2.99276L13.0074 12.4015ZM12.3996 13.0091C11.2256 14.041 9.68596 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00001C1.3335 6.31421 1.95921 4.77455 2.99107 3.60062L12.3996 13.0091Z",
    fill: "#F94B50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2b7a273ff9435ebe2f5bfef114ea3b2f.svg";
export { ForwardRef as ReactComponent };